import type { CalendarDate } from "@internationalized/date";
import type { FC } from "react";
import { Calendar } from "react-aria-components";
import { Button, ButtonVariant } from "../Buttons/button.js";
import { Size } from "../helpers/helpers.js";
import {
  CalendarDateInput,
  CalendarDateInputBox,
  CalendarMonth,
  CalendarNavigationHeader,
} from "./calendar.js";

export interface SingleDatePickerProps {
  /** Accessible label for the calendar, such as "Signed up is after". */
  "aria-label": string;
  value: CalendarDate;
  /** Latest selectable day. Omit to allow future dates. */
  maxValue?: CalendarDate;
  onChange: (value: CalendarDate) => void;
  onApply: () => void;
}

/**
 * One month of days plus typed entry for a single date, laid out like
 * {@link DateRangeDialog} so the two pickers read as one control.
 */
export const SingleDatePicker: FC<SingleDatePickerProps> = (props) => (
  <div className="p-4">
    <Calendar
      aria-label={props["aria-label"]}
      value={props.value}
      maxValue={props.maxValue}
      onChange={props.onChange}
    >
      <CalendarNavigationHeader monthFormat="short" />
      <CalendarMonth selectionMode="single" />
    </Calendar>

    <div className="mt-4 flex items-center justify-between gap-2">
      <CalendarDateInputBox className="min-w-0 flex-1">
        <CalendarDateInput
          ariaLabel="Date"
          value={props.value}
          isRequired
          maxValue={props.maxValue}
          onChange={props.onChange}
          onEnter={props.onApply}
        />
      </CalendarDateInputBox>

      <Button
        size={Size.MEDIUM}
        variant={ButtonVariant.Primary}
        className="shrink-0"
        onClick={props.onApply}
      >
        Apply
      </Button>
    </div>
  </div>
);
